export const AppPublicKey = `BC0eT9811BZJhoVN0gNmgo1pBXh4J6nzdMpJbIvBqnFa1HL5HCgkKn6Un-fxiXorETOoeWuB6rwGfPBn0JL_490`
